import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';
import { rootRouteRef, pageDetailRouteRef, userDetailRouteRef } from './routes';

export const analyticsPlugin = createPlugin({
  id: 'analytics',
  routes: {
    root: rootRouteRef,
    pageDetail: pageDetailRouteRef,
    userDetail: userDetailRouteRef,
  },
});

export const AnalyticsPage = analyticsPlugin.provide(
  createRoutableExtension({
    name: 'AnalyticsPage',
    component: () =>
      import('./components/AnalyticsPage').then(m => m.AnalyticsPage),
    mountPoint: rootRouteRef,
  }),
);

export const PageDetailPage = analyticsPlugin.provide(
  createRoutableExtension({
    name: 'PageDetailPage',
    component: () =>
      import('./components/PageDetailPage').then(m => m.PageDetailPage),
    mountPoint: pageDetailRouteRef,
  }),
);

export const UserDetailPage = analyticsPlugin.provide(
  createRoutableExtension({
    name: 'UserDetailPage',
    component: () =>
      import('./components/UserDetailPage').then(m => m.UserDetailPage),
    mountPoint: userDetailRouteRef,
  }),
);
